import { render } from "./ShowStudent.vue?vue&type=template&id=4e0caf67&scoped=true"
import script from "./ShowStudent.vue?vue&type=script&lang=js"
export * from "./ShowStudent.vue?vue&type=script&lang=js"

import "./ShowStudent.vue?vue&type=style&index=0&id=4e0caf67&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e0caf67"]])

export default __exports__